"use client";

import * as React from "react";

import { IRoutingContext } from "./types";

export const RoutingContext: React.Context<IRoutingContext> =
  React.createContext({
    locale: undefined,
    canonicalLocale: "en-US",
    localeCountryUrlPrefix: "",
    robotLocalePrefix: undefined,
    transformHref: undefined,
    Link: undefined,
    getShouldUseSoftNavigation: undefined,
  } as IRoutingContext);
